module.exports = __webpack_public_path__ + "img/credit_tip.25d3a990.svg";